import React from "react";
import { Link } from "react-router-dom";
import MainLogo from "../../imgs/main-logo.png";

const Logo = () => {
  return (
    <Link to="/" className="block">
      <img
        src={MainLogo}
        alt="Pancham Records"
        className="w-32 sm:w-36 md:w-48 lg:w-52 max-w-full h-auto max-h-24 sm:max-h-28 md:max-h-32 object-contain"
      />
    </Link>
  );
};

export default Logo;
